module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-28.e2aae547.png";